import { Chip, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useStyles from "./styles";

// Selo que identifica o ERP de origem de um registro (HUBSOFT, IXC...).
// Recebe o ERP como vem do backend: { tipo, nome }. Sem ERP, não renderiza.
export default function ErpChip({ erp, sx = {} }) {
  const theme = useTheme();
  const styles = useStyles(theme);

  if (!erp?.tipo) return null;

  return (
    <Tooltip title={erp.nome || erp.tipo}>
      <Chip
        label={erp.tipo}
        size="small"
        sx={{ ...(styles.porTipo[erp.tipo] || styles.padrao), ...sx }}
      />
    </Tooltip>
  );
}
